<template>
    <div class="panel panel-default">
        <div class="panel-heading"></div>
        <div class="row panel-body">
            <div class="col-md-3 col-sm-4 col-xs-6 form-group">
                <label>Start Date</label><DatePicker v-model="state.optionFields.startDate.val" :inputAttributes="{class: 'form-control', disabled: state.optionFields.notShippedYet.val}"></DatePicker>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-6 form-group">
                <label>End Date</label><DatePicker v-model="state.optionFields.endDate.val" :input-attributes="{class: 'form-control', disabled: state.optionFields.notShippedYet.val}"></DatePicker>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-6 form_grid">
                <label><input type='checkbox' @click="toggleDatePickers($event)" :true-value="1" :false-value=null v-model="state.optionFields.notShippedYet.val" > Not shipped yet</label>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-6 form_grid">
                <label><input type='checkbox' :true-value="1" :false-value=null v-model="state.optionFields.cdiErrorOnly.val" > CDI error only</label>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-6 form-group">
                <label>CDI Location</label>
                <select class="form-control" v-model="state.optionFields.cdiLocationId.val">
                    <option value="0">All</option>
                    <option v-for="[id, location] in cache.cdiLocationCache.CDI_LOCATIONS" v-bind:key="id" :value="id">{{ location }}</option>
                </select>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-6 form-group">
                <label>Sales Person</label>
                <Typeahead cdi_type="sales_employee" v-bind:ID.sync="state.optionFields.salesPersonId.val" />
            </div>
            <div class="col-md-3 col-sm-4 col-xs-6 form-group">
                <label>Type</label>
                <select class="form-control" v-model="state.optionFields.type.val">
                    <option value="0">All</option>
                    <option v-for="[id, type] in cache.trackerCache.REMAKE_TYPES" v-bind:key="id" :value="id">{{ type }}</option>
                </select>
            </div>
            <div class="col-md-3 col-sm-4 col-xs-6 form-group">
                <label>Special Tag</label>
                <select class="form-control" v-model="state.optionFields.specialTag.val">
                    <option value="0">All</option>
                    <option v-for="[id, tag] in cache.userCache.USER_SPECIAL_TAGS" v-bind:key="id" :value="id">{{ tag }}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    import { store } from '@/store/Report.store.js';
    import cdiLocationCache from '@/cache/cdiLocation.cache.js';
    import trackerCache from '@/cache/tracker.cache.js';
    import userCache from '@/cache/user.cache.js';
    import DatePicker from "../utils/DatePicker";
    import Typeahead from "@/components/utils/typeaheads/Typeahead";

    export default {
        name: "brand_sales_opt",
        components: {DatePicker, Typeahead},
        data() {
            return {
                storeStartDate: '',
                storeEndDate: '',
                state: store.state,
                cache: {
                    cdiLocationCache,
                    trackerCache,
                    userCache,
                    DatePicker
                }
            }
        },
        methods: {
            toggleDatePickers: function(evt) {
                if (evt.target.checked == true) {
                    this.storeStartDate = this.state.optionFields.startDate.val;
                    this.state.optionFields.startDate.val = '';
                    this.storeEndDate = this.state.optionFields.endDate.val;
                    this.state.optionFields.endDate.val = '';
                } else {
                    this.state.optionFields.startDate.val = this.storeStartDate;
                    this.state.optionFields.endDate.val = this.storeEndDate;
                }
            }
        }
    }
</script>

<style scoped>

</style>